
import { Options, Vue, prop } from "vue-class-component";
import Toggle from "@/app/ui/components/toggle/index.vue";
import { RevenueDashboardController } from "@/app/ui/controllers/RevenueDashboardController";
import { RevenueDashboardState } from "@/domain/entities/RevenueDashboard";

class Props {
  data = prop<RevenueDashboardState>({
    default: () => new RevenueDashboardState()
  });
}


@Options({
  components: { Toggle },
  emits: ["filter"]
})
export default class RevenueMetricFilter extends Vue.with(Props) {
  // Daftar metric filter
  metricFilters = [
    { key: 'omzet', labelKey: 'dashboard.metrics.revenue' },
    { key: 'stt', labelKey: 'dashboard.metrics.stt' },
    { key: 'berat', labelKey: 'dashboard.metrics.weight' },
  ];

  // Access controller state via class getter
  get activeMetricFilter(){
    return this.data.dataGrouping;
  }

  // Handles metric change event and calls controller action directly
  handleMetricChange(filter: "omzet" | "stt" | "berat"): void {
    this.data.dataGrouping = filter;
    this.$emit("filter")
  }
}
